export default class PlanoContaContabil {
    
    constructor(model = null){
        this.id = 0;
        this.empresaId = 0;
        this.classificador = '';
        this.codigoReduzido = '';
        this.nome = '';
        this.tipo = '';
        this.tipoConta = 'A';
        this.codigoNome = '';

        if (!model)
            return;
        
        this.id = model.id ? model.id : 0;
        this.empresaId = model.empresaId;
        this.classificador = model.classificador;
        this.codigoReduzido = model.codigoReduzido || '';
        this.nome = model.nome;
        this.tipo = model.tipo;
        this.tipoConta = model.tipoConta || 'A';
        this.tipoContaStr = model.tipoContaStr;
        this.codigoNome = model.codigoNome;
        this.itens = model.itens;
    }
}
